export default "__VITE_ASSET__Dq53l2pV__"